/* Copyright (c) 2017 Backpack Health LLC */

import { connect } from 'react-redux';
import * as _ from 'lodash';

import MfaLogin from './MfaLogin.controller';

import RouteNames from '../../appAuthorized/RouteNames';
import tokenDurations from '../../../constants/tokenDurations';
import AppUtils from '../../../utilities/AppUtils';
import { authToken } from '../../../utilities/LocalStorage';
import { actions as userActions } from '../../redux/ducks/user';
import { navigateBack } from '../../appAuthorized/redux/NavigationActions';

function mapStateToProps(state, routerProps) {
  const queryParams = AppUtils.getQueryParams(routerProps.location.search);
  const duration = _.includes([tokenDurations.SHORT, tokenDurations.LONG], queryParams.duration) ? queryParams.duration : tokenDurations.SHORT;

  return {
    duration,
    isMissingMfaToken: !authToken.get(),
    goBack: () => {
      navigateBack(RouteNames.loginpassword());
    },
  };
}

function mapDispatchToProps(dispatch) {
  return {
    submitUserUpdate: (userData, callback) => {
      dispatch(userActions.submitUserUpdate(userData, callback));
    },
  };
}


export default connect(mapStateToProps, mapDispatchToProps)(MfaLogin);
